import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import work from '../actions/work';
import theme from '../actions/theme';
import BlomArchive from '../pages/BlomArchive';

const mapStateToProps = state => ({
  blom: state.work.blomArchive,
  next: state.work.unionSquare,
  prev: state.work.sketches,
  theme: state.theme,
});
const mapDispatchToProps = dispatch => ({
  load: bindActionCreators(work.fetch, dispatch),
  loadTheme: bindActionCreators(theme.fetch, dispatch),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BlomArchive);



// WEBPACK FOOTER //
// ./src/containers/BlomArchive.js